<script>
    export let color;
</script>

<svelte:options namespace="svg"/>

<svg width="32" height="16">
    <rect width="32" height="16" rx="2" fill={color} />
</svg>